import { createAction, props } from '@ngrx/store';
import { ListPageState } from '../models/list-state.model';

export const saveListState = createAction(
    '[List] Save',
    props<{
        pageKey: string;
        state: ListPageState;
    }>()
);

export const clearListState = createAction(
  '[List] Clear State',
  props<{ pageKey: string }>()
);